import gql from 'graphql-tag';

const GET_ALL_TICKET_FORMS = gql`
  query {
    getAllTicketForms {
      formId
      formName
      formDescription
      formStatus
      subject
      description
      fieldDetails
      defaultForm
      standardOperatingProcedure {
        sopId
        name
      }
    }
  }
`;

const GET_PUBLISHED_TICKET_FORMS = gql`
  query {
    getPublishedTicketForms {
      formId
      formName
      formDescription
      formStatus
      subject
      description
      fieldDetails
      standardOperatingProcedure {
        sopId
        name
      }
    }
  }
`;

const GET_PUBLISHED_TICKET_FORMS_NEW = gql`
  query {
    getPublishedTicketForms {
      formId
      formName
      formDescription
      formStatus
      subject
      description
      fieldDetails
      runbook {
        sopId
        name
      }
    }
  }
`;

const GET_PUBLISHED_TICKET_FORM_TRAY = gql`
  query {
    getPublishedTicketForms {
      formId
      formName
      formDescription
      clientVisibility
      formStatus
      subject
      description
    }
  }
`;

const GET_TICKET_FORM = gql`
  query($ticketFormId: ID!) {
    getTicketForm(ticketFormId: $ticketFormId) {
      formId
      formName
      formDescription
      formStatus
      allowDeleteOrClientVisibilityUpdate
      subject
      description
      fieldDetails
      standardOperatingProcedure {
        sopId
        name
      }
      clientVisibility
      clients {
        accountId
        name
      }
      defaultForm
      requesterGroupVisibility
      requesterGroups {
        groupId
        name
      }
    }
  }
`;

const GET_TICKET_FORM_NEW = gql`
  query($ticketFormId: ID!) {
    getTicketForm(ticketFormId: $ticketFormId) {
      formId
      formName
      formDescription
      formStatus
      allowDeleteOrClientVisibilityUpdate
      subject
      description
      fieldDetails
      runbook {
        sopId
        name
      }
      clientVisibility
      clients {
        accountId
        name
      }
      defaultForm
      requesterGroupVisibility
      requesterGroups {
        groupId
        name
      }
    }
  }
`;

const GET_TICKET_FORM_FOR_DROPDOWN = gql`
  query {
    getPublishedTicketForms {
      formId
      formName
    }
  }
`;

const GET_TICKET_FORM_FOR_IT = gql`
  query($ticketFormId: ID!) {
    getTicketForm(ticketFormId: $ticketFormId) {
      formId
      formName
      formDescription
      formStatus
      subject
      description
      fieldDetails
      standardOperatingProcedure {
        sopId
        name
      }
      defaultForm
    }
  }
`;

const GET_TICKET_FORM_SYSTRAY = gql`
  query($ticketFormId: ID!, $client: ClientIdentifierInput) {
    getTicketForm(ticketFormId: $ticketFormId, client: $client) {
      formId
      formName
      subject
      description
      fieldDetails
      runbook {
        sopId
        name
      }
    }
  }
`;

const GET_DEFAULT_TICKET_FORM = gql`
  query {
    getDefaultTicketForm {
      formId
      formName
      formDescription
      formStatus
      subject
      description
      fieldDetails
      standardOperatingProcedure {
        sopId
        name
      }
    }
  }
`;

const GET_DEFAULT_TICKET_FORM_NEW = gql`
  query {
    getDefaultTicketForm {
      formId
      formName
      formDescription
      formStatus
      subject
      description
      fieldDetails
      runbook {
        sopId
        name
      }
    }
  }
`;

export {
  GET_ALL_TICKET_FORMS,
  GET_PUBLISHED_TICKET_FORMS,
  GET_TICKET_FORM,
  GET_TICKET_FORM_FOR_IT,
  GET_TICKET_FORM_SYSTRAY,
  GET_DEFAULT_TICKET_FORM,
  GET_PUBLISHED_TICKET_FORM_TRAY,
  GET_TICKET_FORM_NEW,
  GET_DEFAULT_TICKET_FORM_NEW,
  GET_PUBLISHED_TICKET_FORMS_NEW,
  GET_TICKET_FORM_FOR_DROPDOWN
};
